import { useState } from "react";

const GradeTab = ({
  groupedStudents,
  handleClickAllStudents,
  handleClickStudent,
  selectedParams,
}) => {
  const [expandedLevels, setExpandedLevels] = useState({});

  const handleToggle = (levelId) => {
    setExpandedLevels((prev) => ({
      ...prev,
      [levelId]: !prev[levelId],
    }));
  };

  const styles = {
    classDetail: {
      fontSize: "12px",
      fontWeight: 700,
      color: "#7A8490",
      flexShrink: 0,
    },
    classHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "10px",
      padding: "10px 16px",
      margin: "4px 8px",
      border: "none",
      fontSize: "14px",
      fontWeight: 600,
      cursor: "pointer",
      whiteSpace: "nowrap",
      transition: "background-color .12s, border-radius .12s",
    },
    studentList: {
      listStyle: "none",
      padding: 0,
      margin: 0,
      overflow: "hidden",
      maxHeight: "0",
      transition: "max-height 0.3s ease, opacity 0.3s ease",
      opacity: 0,
      fontSize: "14px",
    },
    studentListVisible: {
      maxHeight: "none",
      opacity: 1,
    },
    studentItem: {
      display: "flex",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      padding: "8px 16px 8px 34px",
      backgroundColor: "#fff",
      color: "#7A8490",
      border: "none",
      fontWeight: 600,
      cursor: "pointer",
      borderRadius: "999px",
      margin: "0 8px",
    },
  };

  return Object.entries(groupedStudents).map(([grade, { name, students }]) => (
    <li key={grade}>
      <div
        style={{
          backgroundColor: expandedLevels[grade] ? "#E5FBF8" : "#fff",
          color: expandedLevels[grade] ? "#0E141B" : "#3A434E",
          fontWeight: expandedLevels[grade] ? 800 : 600,
          borderRadius: expandedLevels[grade] ? "999px" : "0",
          ...styles.classHeader,
        }}
        onClick={() => handleToggle(grade)}
      >
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", minWidth: 0 }}>{name}</span>
        <span style={styles.classDetail}>{students.length}명</span>
      </div>
      <ul
        style={{
          ...styles.studentList,
          ...(expandedLevels[grade] ? styles.studentListVisible : {}),
        }}
      >
        <li
          key={"group_" + grade}
          style={{
            ...styles.studentItem,
            color: selectedParams.studentGrade === grade ? "#00A396" : "#7A8490",
            fontWeight: "bold",
          }}
          onClick={() => handleClickAllStudents(grade)}
        >
          전체 학생
        </li>
      </ul>
      <ul
        style={{
          ...styles.studentList,
          ...(expandedLevels[grade] ? styles.studentListVisible : {}),
        }}
      >
        {students.map((student) => (
          <li
            key={student.id}
            style={{
              ...styles.studentItem,
              color:
                selectedParams.studentId === student.id ? "#00A396" : "#7A8490",
              fontWeight:
                selectedParams.studentId === student.id ? 800 : 600,
            }}
            onClick={() => handleClickStudent(student.id)}
          >
            {student.name}
          </li>
        ))}
      </ul>
    </li>
  ));
};

export default GradeTab;
